const ADS_IDS = {
  MOBILE: {
    SINGLE: {
      DIV: 'div-gpt-ad-1581706432720-0',
      SLOT: '/21757582265/Product_Search_Left_212x150'
    },
    SIZE: [212, 150]
  },
  DESKTOP: {
    LEFT: {
      DIV: 'div-gpt-ad-1581706634680-0',
      SLOT: '/21757582265/Product_Search_L'
    },
    RIGHT: {
      DIV: 'div-gpt-ad-1581706797252-0',
      SLOT: '/21757582265/Product_Search_R'
    },
    SIZE: [776, 150]
  },
  LAPTOP: {
    LEFT: {
      DIV: 'div-gpt-ad-1581706573772-0',
      SLOT: '/21757582265/Product_Search_Left_527x150'
    },
    RIGHT: {
      DIV: 'div-gpt-ad-1581706851930-0',
      SLOT: '/21757582265/Product_Search_R_527x150'
    },
    SIZE: [527, 150]
  },
  TABLET: {
    LEFT: {
      DIV: 'div-gpt-ad-1581706497366-0',
      SLOT: '/21757582265/Product_Search_L_427x150'
    },
    RIGHT: {
      DIV: 'div-gpt-ad-1581706903564-0',
      SLOT: '/21757582265/Product_Search_R_427x150'
    },
    SIZE: [427, 150]
  },
  SMALL_TABLET: {
    LEFT: {
      DIV: 'div-gpt-ad-1581706432720-0',
      SLOT: '/21757582265/Product_Search_Left_212x150'
    },
    RIGHT: {
      DIV: 'div-gpt-ad-1581706949380-0',
      SLOT: '/21757582265/Product_Search_R_212x150'
    },
    SIZE: [212, 150]
  }
};

function getAdsIds() {
  const width = window.innerWidth;
  if (width >= 1720) {
    return ADS_IDS.DESKTOP;
  } else if (width >= 1200) {
    return ADS_IDS.LAPTOP;
  } else if (width >= 992) {
    return ADS_IDS.TABLET;
  } else if (width >= 464) {
    return ADS_IDS.SMALL_TABLET;
  }
  return ADS_IDS.MOBILE;
}

module.exports = getAdsIds;
